import React, { useState, useEffect } from 'react';
import { Button, Table, message, Popconfirm, Tooltip,Typography } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import 'antd/dist/reset.css';
import CreateEmailTemplate from './CreateEmailTemplate'; // Import the CreateTemplate component
import ApiService from '../Components/apiService';
import { BASE_URL,DateFormat,DateTimeFormat } from '../Components/Constant';
import dayjs from 'dayjs';
import {convertDateToUserTimezone} from '../Components/Utility';
import { useSelector } from 'react-redux';

const { Title } = Typography;

const EmailTemplate = () => {
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const security = useSelector((state) => state.data.items[0]);

  useEffect(() => {
    fetchEmailTemplate();
  }, []);

  const fetchEmailTemplate = async () => {
    try {
      const apiServiceForEmail = new ApiService(
        `${BASE_URL}/get_all_template`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForEmail.makeCall();


      if (Array.isArray(response)) {
        const templates = response.map((template) => ({
          key: template._id,
          name: template.template_name,
          object: template.object_name,
          subject: template.subject,
          ...template,
        }));
      setEmailTemplate(templates);
    } else {
        message.warning('No email templates found.');
      }

    } catch (error) {
    }
  };

  const handleEditClick = (template) => {
    if(security?.system_settings?.email_template?.edit===false){
      message.error('You do not have permission to edit email templates');
      return;
    }
    setSelectedTemplate(template);
    setShowCreateTemplate(true);
  };

  const deleteEmailTemplate = async (template) => {
    if(security?.system_settings?.email_template?.delete===false){
      message.error('You do not have permission to delete email templates');
      return;
    }
    try {
      // Create ApiService instance for DELETE request
      const apiService = new ApiService(
        `${BASE_URL}/delete_template/${template._id}`,
        { 'Content-Type': 'application/json' },
        'DELETE'
      );
      await apiService.makeCall();
      fetchEmailTemplate();

      message.success('Email template deleted successfully.');
    } catch (error) {
      message.error('Failed to delete email template.');
      console.error('Error deleting email template:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Template Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
        title: 'Object',
        dataIndex: 'object',
        key: 'object',
        sorter: (a, b) => a.object.localeCompare(b.object),
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      // width: 100,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (text) => (
        text && dayjs(text).isValid()
          ? convertDateToUserTimezone(text, DateTimeFormat)
          : ''
      ),
      
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      // width: 100,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (text) => (
        text && dayjs(text).isValid()
          ? convertDateToUserTimezone(text, DateTimeFormat)
          : ''
      ),
      
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <EditOutlined
              style={{ cursor: 'pointer', color: 'blue', marginRight: 10 }}
              onClick={() => handleEditClick(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
          <Popconfirm
            title="Are you sure you want to delete this item?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
                deleteEmailTemplate(record)
            }
            }

          >
            <DeleteOutlined style={{ color: 'red', marginRight: 8, fontSize: '14px', cursor: 'pointer' }} />
          </Popconfirm>
        </Tooltip>
         
        </>
      ),
    },
  ];


  // Toggle the CreateTemplate view
  const handleCreateTemplateClick = () => {
    if(security?.system_settings?.email_template?.create===false){
      message.error('You do not have permission to create email templates');
      return;
    }
    setSelectedTemplate(null); // Clear selected template
    setShowCreateTemplate(true);
  };

  return (
    <div style={{ padding: '10px' }}>
      {showCreateTemplate ? (
        <CreateEmailTemplate fetchEmailTemplate={fetchEmailTemplate} visible={handleCreateTemplateClick} template={selectedTemplate} onClose={() => setShowCreateTemplate(false)} /> // Render the CreateTemplate component
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px',
            }}
          >
            <Title level={4} >Email Templates</Title>
            <Button type="primary" onClick={handleCreateTemplateClick} >
              Create Template
            </Button>
          </div>
          <Table columns={columns} dataSource={emailTemplate} scroll={{ y: 550 }}
              pagination={{
              pageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              onChange: (page, pageSize) => {
                setPageSize(pageSize);
              },              
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }} />
        </>
      )}
    </div>
  );
};

export default EmailTemplate;